import React from 'react';

interface IconClipboardProps {
    iconClasses?: string;
}

const IconClipboard: React.FC<IconClipboardProps> = ({ iconClasses }) => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-clipboard ${iconClasses ?? ''}`}
        >
            <path
                d="M17.7706 2.99998L16.5706 0.599976H13.429L12.229 2.99998H10.1998V4.19998H4.7998V29.4H25.1998V4.19998H19.7998V2.99998H17.7706ZM12.9706 4.19998L14.1706 1.79998H15.829L17.029 4.19998H18.5998V7.79998H11.3998V4.19998H12.9706ZM19.7998 8.99998V7.79998H21.5998V25.8H8.3998V7.79998H10.1998V8.99998H19.7998ZM23.9998 5.39998V28.2H5.9998V5.39998H10.1998V6.59998H7.1998V27H22.7998V6.59998H19.7998V5.39998H23.9998Z"
                fill="currentColor"
            />
            <path
                d="M14.4002 3.59998H15.6002V4.79998H14.4002V3.59998ZM20.2244 13.6242L19.376 12.7758L13.2002 18.9516L11.2244 16.9758L10.376 17.8242L13.2002 20.6484L20.2244 13.6242Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconClipboard;
